import React, { Component } from 'react';
import Sidemenu from '../SideMenu/SideMenu';
import { convertUTCToLocalDateTime } from '../../helpers/GlobalFunctions';
import { DataTable } from '../DataTable/DataTable';
import { auditLogs } from '../../helpers/messages';
import ExportData from './ExportData';
import LogsFilterContainer from './LogsFilter';

class Logs extends Component {
	constructor() {
		super()
		this.state = {
			reloadList: '', filterObj: '', count: '', refreshDataList: true
		}
	}

	/**
	 * @description function to get count 
	 * @param {*}
	 * @memberof Logs
	 */
	/* istanbul ignore next  */
	setTotalCount = (val) => {
		// this.setState({ count: val, refreshDataList: false })
	}

	/**
	 * @description function to get filter obj as props from filter component 
	 * @param {*}
	 * @memberof Logs
	 */
	/* istanbul ignore next  */
	getLogsFilterObj = (obj) => {
		this.setState({ filterObj: obj, refreshDataList: true });
	}

	/**
	 * @description function to handle refreshing logs list
	 * @memberof Logs
	 */
	refreshLogs = () => {
		this.setState({ reloadList: true, refreshDataList: true });
		/* istanbul ignore next  */
		setTimeout(() => {
			this.setState({ reloadList: false });
		}, 2000);
	}
	/**
     * @description function to handle serialNo display
     * @param {*}
     * @memberof Header
     */
	 /* istanbul ignore next  */
	 getSerialNoColumnData = (data) => {
		return data?.length > 10 ? <div title={data}>{data.substring(0, 7) + '...'}</div> : data;
	}

	render() {
		/* istanbul ignore next  */
		const columns = [
			{
				Header: 'Event Date & Time',
				accessor: 'EventDate',
				Cell: ({ row }) => row.original.EventDate ? convertUTCToLocalDateTime(row.original.EventDate) : '',
				Filter: ''
			},
			{
				Header: 'Event Name',
				accessor: 'EventName',
				Filter: ''
			},
			{
				Header: 'Event Outcome',
				accessor: 'EventOutcome',
				Filter: ''
			},
			{
				Header: 'Event Type',
				accessor: 'EventType',
				Filter: ''
			},
			{
				Header: 'Username',
				accessor: 'UserID',
				Filter: ''
			},
			{
				Header: 'Time Spent (Seconds)',
				accessor: 'Content.TimeSpent',
				Cell: ({ row }) => row.original.Content && row.original.Content.TimeSpent ? parseFloat(row.original.Content.TimeSpent).toFixed(2) : '',
				Filter: ''
			},
			{
				Header: 'CORI SN',
				accessor: 'Content.serialNo',
				Cell: ({ row }) => row.original.Content && row.original.Content.serialNo ? this.getSerialNoColumnData(row.original.Content.serialNo) : 'N/A',
				Filter: ''
			},
			{
				Header: 'Case ID',
				accessor: 'Content.CaseId',
				Cell: ({ row }) =>  row.original?.Content?.CaseId || '',
				Filter: ''
			},
			{
				Header: 'Message',
				accessor: 'Content.Data',
				Cell: ({ row }) => row.original.Content && row.original.Content.Data ? row.original.Content.Data : '',
				Filter: ''
			}
		]
		return (<div>
			<div className="bgGray">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-1">
							<Sidemenu />
						</div>
						<div className="col-md-11">
							<div className="data-list-tabs caselist-tabs" data-testid="logs-filter" >
								<LogsFilterContainer id="logs-filter" setLogsFilterObj={this.getLogsFilterObj} />
								<div className="app-logs">
									<ExportData totalCount={this.state.count} filterObj={this.state.filterObj} refreshLogs={this.refreshLogs} />
									{this.state.reloadList ?
										<p className="text-success text-center py-4">{auditLogs.refreshing}</p>
										: <DataTable totalCount={this.setTotalCount} listType="audit-logs" columns={columns} showPagination={true} disableColmSort={true}
											filterObj={this.state.filterObj}
										/>
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>);
	}
}
export default Logs;
